export const dateFormatter = (timestamp) => {
  if (timestamp === null || timestamp === undefined || timestamp === "") {
    return "";
  }

  const date = new Date(Number(timestamp));
  if (isNaN(date.getTime())) return "Invalid Date";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 0-based
  const year = date.getFullYear(); // ✅ 4-digit year

  return `${day}/${month}/${year}`;
};
export const formatToYYYYMMDD = (dateString) => {
  if (!dateString) return "";

  const [day, month, year] = dateString.split("/");
  if (!day || !month || !year) return "";

  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};
export const convertToTimestamp = (dateString) => {
  if (!dateString) return null;
  return new Date(dateString).getTime(); // returns ms
};

export const ddMMyyyyToTimestamp = (dateString) => {
  if (!dateString) return null;

  const [day, month, year] = dateString.split("/");
  if (!day || !month || !year) return null;

  // month is 0-based in JS Date
  const date = new Date(Number(year), Number(month) - 1, Number(day));

  return date.getTime(); // milliseconds
};
